export default __webpack_public_path__ + "static/media/Calendar_Add_Update.5ea790d7.png";